import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { Home, Film, Search, BookOpen, User } from 'lucide-react';

const MobileHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-header);
  display: none;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: flex;
  }
`;

const Logo = styled(Link)`
  font-size: 1.3rem;
  font-weight: bold;
  color: #FFD700;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #FFF;
  }
`;

const NavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px 0;
  z-index: 2000; // z-index élevé pour être au-dessus des pubs et overlays
  display: none;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: block;
  }
`;

const NavList = styled.ul`
  display: flex;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavItem = styled.li`
  text-align: center;
`;

interface NavLinkProps {
  $isActive: boolean;
}

const NavLink = styled(Link)<NavLinkProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.$isActive ? 'var(--color-primary)' : 'var(--color-text-primary)'};
  text-decoration: none;
  font-size: 0.75rem;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    color: var(--color-primary);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const Label = styled.span`
  font-size: 0.7rem;
  font-weight: 500;
`;

export const MobileNavBar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <MobileHeader id="cdx-mobile-header">
        <Logo to="/">Cinédelux</Logo>
      </MobileHeader>
      <NavContainer id="cdx-mobile-nav">
        <NavList>
          <NavItem>
            <NavLink to="/" $isActive={isActive('/')}>
              <Home />
              <Label>Home</Label>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/browse" $isActive={isActive('/browse')}>
              <Film />
              <Label>Movies</Label>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/search" $isActive={isActive('/search')}>
              <Search />
              <Label>Search</Label>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/blog" $isActive={isActive('/blog')}>
              <BookOpen />
              <Label>Blog</Label>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/profile" $isActive={isActive('/profile')}>
              <User />
              <Label>Profile</Label>
            </NavLink>
          </NavItem>
        </NavList>
      </NavContainer>
    </>
  );
};

export default MobileNavBar;
